import React from "react";
import { Outlet } from "react-router-dom";
import { ThemeProvider } from "web-ui";
import InternalRootThemeProvider from "web-ui/components/internal/RootThemeProvider";
import { COLORS } from "web-ui/util/color";

import styles from "./App.module.scss";
import { Error } from "./components/Error";
import TopBar from "./components/TopBar";
import UserContextManager, { useUser } from "./components/UserContextManager";

const InnerApp = () => {
  const user = useUser();
  // Since the user will be undefined while we wait to check the JWT, we need to
  // wait until we've loaded the user before rendering the app or else the logged-out
  // experience briefly flashes even for logged-in, authorized users.
  return user === undefined ? null : user?.roles.includes("admin") ||
    user?.roles.includes("tts-data-contributor") ? (
    <>
      <TopBar />
      <div className={styles["content"]}>
        <Outlet />
      </div>
    </>
  ) : (
    <Error subject="You do not currently have permission to view this page. Ensure you are signed in at duolingo.com." />
  );
};

const App = () => (
  <UserContextManager>
    <InternalRootThemeProvider theme="light">
      <ThemeProvider colors={COLORS} theme="light">
        {({ style }) => (
          <div className={styles["app"]} style={style}>
            <InnerApp />
          </div>
        )}
      </ThemeProvider>
    </InternalRootThemeProvider>
  </UserContextManager>
);

export default App;
